"use client";

import { useCallback, useState } from "react";

const preservedLoadedPageCounts = new Map<string, number>();

export default function usePreservedLoadedPageCount(key: string) {
  const [loadedPageState, setLoadedPageState] = useState(() => ({
    key,
    loadedPageCount: preservedLoadedPageCounts.get(key) ?? 1,
  }));

  const loadedPageCount =
    loadedPageState.key === key
      ? loadedPageState.loadedPageCount
      : (preservedLoadedPageCounts.get(key) ?? 1);

  const loadMore = useCallback(() => {
    setLoadedPageState((currentState) => {
      const currentPageCount =
        currentState.key === key
          ? currentState.loadedPageCount
          : (preservedLoadedPageCounts.get(key) ?? 1);
      const nextPageCount = currentPageCount + 1;

      preservedLoadedPageCounts.set(key, nextPageCount);

      return {
        key,
        loadedPageCount: nextPageCount,
      };
    });
  }, [key]);

  return {
    loadedPageCount,
    loadMore,
  };
}
